import isEmpty from 'lodash/isEmpty';

export const criteria = {
  accessibility_contrast: crit => crit && crit.data,
  accessibility_navigation: crit => crit && crit.data,
  amp: crit => crit && crit.data,
  analytics_technologies: crit => crit && crit.data,
  backlinks_counter: crit => crit && crit.data && typeof crit.data === 'number',
  backlinks_ref_domains: crit => crit && crit.data && typeof crit.data === 'number' && crit.data >= 0,
  backlinks_score: crit => crit && crit.data && typeof crit.data.score === 'number',
  broken_links: crit => crit && crit.data,
  canonical_tags: crit => crit && crit.data,
  clean_url: crit => crit && crit.data,
  crunchbase: crit => crit && crit.data && crit.data.detected,
  custom_404: crit => crit && crit.data,
  description: crit => crit && crit.data,
  discovered_social_profiles: crit => crit && crit.data,
  dmarc: crit => crit && crit.data,
  doctype: crit => crit && crit.data,
  domain_registration: crit => !isEmpty(crit),
  email_security: crit => crit && crit.data,
  encoding: crit => !isEmpty(crit),
  facebook_brand_page: crit => crit && crit.data,
  favicon: crit => crit && crit.data,
  google_preview: crit => crit && crit.data,
  gwt_queries: crit => crit && crit.data,
  headings: crit => crit && crit.data,
  hreflang: crit => crit && crit.data,
  image_optimization: crit => crit && crit.data,
  images: crit => crit && crit.data,
  indexed_pages: crit => crit && crit.data,
  instagram: crit => crit && crit.data,
  ip_information: crit => crit && crit.data,
  keywords_cloud: crit => crit && crit.data,
  language: crit => crit && crit.data,
  largest_contentful_paint_element: crit => crit && crit.data,
  layout_shift_elements: crit => crit && crit.data,
  linkedin: crit => crit && crit.data,
  links_details: crit => crit && crit.data,
  local_directories: crit => crit && crit.data,
  local_online_reviews: crit => crit && crit.data,
  microformats: crit => crit && crit.data,
  mixed_content: crit => crit && crit.data,
  mobile_compatibility: crit => crit && crit.data,
  mobile_fontsize: crit => crit && crit.data,
  mobile_frameworks: crit => crit && crit.data,
  mobile_friendliness: crit => crit && crit.data,
  mobile_rendering: crit => crit && crit.data && (crit.data.phone || crit.data.tablet),
  mobile_taptargets: crit => crit && crit.data,
  mobile_viewport: crit => crit && crit.data,
  noindex_nofollow: crit => crit && crit.data,
  open_graph: crit => crit && crit.data,
  pj_backlinks_quality: crit => crit && crit.data,
  pj_uptime: crit => crit && crit.data,
  resources_cacheability: crit => crit && crit.data,
  resources_compression: crit => crit && crit.data,
  resources_minification: crit => crit && crit.data,
  robots_tags: crit => crit && crit.data,
  robots_txt: crit => crit && crit.data,
  schema_org: crit => crit && crit.data,
  shared_count: crit => crit && crit.data,
  sitemaps_validity: crit => crit && crit.data && crit.data.sitemaps && crit.data.sitemaps.length > 0,
  ssl_secured: crit => crit && crit.data,
  technologies: crit => crit && crit.data,
  title: crit => crit && crit.data,
  tld_cybersquating_prevention: crit => crit && crit.data,
  traffic_engagement: crit => crit && crit.data && !isEmpty(crit.data),
  traffic_estimation: crit => crit && crit.data,
  traffic_monthly_visits: crit => crit && crit.data && crit.data.visits && crit.data.visits.length > 0,
  traffic_popularity: crit => crit && crit.data,
  traffic_sources: crit => crit && crit.data && !isEmpty(crit.data),
  traffic_top_countries: crit => crit && crit.data && crit.data.countries && crit.data.countries.length > 0,
  twitter_account: crit => crit && crit.data,
  twitter_card: crit => crit && crit.data,
  typo_cybersquating_prevention: crit => crit && crit.data,
  underscores_url: crit => crit && crit.data,
  url: crit => crit && crit.data,
  web_feeds: crit => crit && crit.data,
  www_resolve: crit => crit && crit.data,
  xml_sitemaps: crit => crit && crit.data
};

export default (crit = {}) => crit && crit.type ? !!criteria[crit.type](crit) : false;
